import dayjs from 'dayjs'
import { extractTextFromMarkdown } from '@/utils/markdownHelper.tsx'
import { marked } from 'marked'
import {uniqueId} from "lodash-es";

// import { isNil } from 'lodash-es'

export class Chat {
  // 消息联系人
  convertContacts = data => {
    // console.log('data', data)
    return data?.map?.(d => {
      const { avatarUrl, id, name, type } = d.contacts

      const attrs = {
        id,
        type,
        avatarUrl: 'saas-obs/202405/664c69f0e4b0a5fcaf4d0f8f.svg',
        time: dayjs(d.message?.createdTime).format('YYYY-MM-DD HH:mm'),
        unReadCount: d.unReadCount,
        message: d.message,
      }

      if (type === 'SYSTEM') {
        return {
          ...attrs,
          name: '系统公告',
          summary: d.message?.body?.title,
        }
      }

      return {
        ...attrs,
        avatarUrl,
        name,
        summary: extractTextFromMarkdown(d.message?.body?.content),
      }
    })
  }

  // 待办消息转换
  convertTodo = data => {
    return data?.map?.(d => {
      const { appName, appIcon, appId, todos, appCode } = d
      return {
        avatarUrl: appIcon,
        id: appId || appCode,
        code: appCode,
        name: appName,
        time: todos[0] ? dayjs(todos[0]?.createdTime).format('YYYY-MM-DD HH:mm') : '',
        summary: todos[0] ? extractTextFromMarkdown(todos[0]?.content) : '',
        unReadCount: d.unFinished,
      }
    })
  }

  // 消息对话框
  convertMessage = (contact, message) => {
    const { avatarSrc, name, type } = contact
    const { id, createdTime, body, bodyType, businessId, businessType, fromId } = message || {}
    const { content, contentType, messageType, coverUrl, buttons, title } = body || {}
    // console.log('convertMessage', message)
    return {
      avatarSrc,
      name,
      time: dayjs(createdTime).format('YYYY-MM-DD HH:mm'),
      type,
      id,
      uid: uniqueId(id),
      read: message.read,
      list: [
        {
          content: marked(content || ''),
          coverUrl,
          contentType: contentType || messageType,
          buttons: buttons?.filter?.(d => !!d.url),
          title,
          businessId,
          businessType,
          fromId,
          body,
        },
      ],
    }
  }

  // 待办对话框
  convertTodoMessage = (contact, message, click) => {
    const { avatarUrl, name } = contact
    const { id, createdTime, content, title, appCode, procDefKey, procInstId, flowTaskId } =
      message || {}
    return {
      avatarSrc: avatarUrl,
      name,
      code: appCode,
      time: dayjs(createdTime).format('YYYY-MM-DD HH:mm'),
      id,
      list: [
        {
          content: marked(content || ''),
          buttons: !flowTaskId ? null : [{ name: '查看详情' }],
          title,
          click: () => click?.({ appCode, procDefKey, procInstId, flowTaskId }),
        },
      ],
    }
  }
}

export default new Chat()
